import React, { useState } from "react";
import HelpIcon from "@mui/icons-material/Help";
import { Tooltip } from "./Tooltip";
import { Target } from "lucide-react";

const DemographicCard = ({ title, items, description ,icon}) => {
  const [showAll, setShowAll] = useState(false);

  const visibleItems = showAll ? items : items?.slice(0, 3);

  return (
    <div className="bg-white rounded-lg p-6 border border-gray-50 shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center gap-2 mb-4">
      <div className="p-2 bg-green-100 rounded-lg">{icon}
            </div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        {description?
        <Tooltip description={description} />:""}
      </div>

      <div className="space-y-4">
        {visibleItems?.map((item, index) => (
          <div key={index}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                {item?.flag && <span className="text-lg">{item?.code}</span>}
                <span className="text-gray-800 text-sm">{item?.name}</span>
              </div>
              <span className="text-gray-500 text-sm">{(item?.weight * 100)?.toFixed(2) || "0.00"}%</span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2">
              <div
                className="bg-gray-800 h-2 rounded-full transition-all duration-300"
                style={{ width: `${(item?.weight * 100)?.toFixed(2) || "0.00"}%` }}
              ></div>
            </div>
          </div>
        ))}

        {/* {items?.length > 3 && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-sm underline transition-colors mt-4 !bg-white"
          >
            {showAll ? "View less" : "View more"}
          </button>
        )} */}
      </div>
    </div>
  );
};

export default DemographicCard;
